export const buildCloudinaryImageUrl = ({
  publicId,
  url,
  width = 400,
  quality = "auto",
  type = "image",
}) => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

  const transformation = `f_auto,q_${quality},w_${width},c_limit`;

  if (publicId) {
    return `https://res.cloudinary.com/${cloudName}/${type}/upload/${transformation}/${publicId}`;
  }

  if (url && url.includes("/upload/")) {
    if (url.includes("f_auto") || url.includes("q_auto")) return url;

    return url.replace("/upload/", `/upload/${transformation}/`);
  }

  return url || "";
};